export const colors = {
  GREEN: '#00984A',
  GREEN_SHINING: '#00D467',
  GREEN_SHINING_ULTRA: '#34EB4F',
  BLACK: '#262626',
  RED: '#EC2127',
  YELLOW: '#ffd500',
  GREEN_LIGHT: '#a7f200',
  GREEN_LIGHT_OPACITY: '#D8FB8A',
  GREEN_LIGHT_TRANSPARENT: 'rgba(167, 242, 0, 0.4)',
  GREEN_ULTRA_LIGHT: '#E0F6CD',
  GREEN_LEAF: '#00AC47',
  GREEN_LEAF_OPACITY: 'rgb(238, 237, 240,0.3)',
  GREEN_LEAF_OPACITY_V2: 'rgba(133,233,170,0.7)',
  PURPLE: '#824bc7',
  WHITE: 'white',
  BLUE_GRAY: '#f6f7fc',
  BLUE: '#15B2FF',
  DARK_BLUE: '#1B77D2',
  BLUE_LIGHT: '#1a90ff',
  BLUE_LIGHT_OPACITY: '#308fe8',
  BLUE_LIGHT_TRANSPARENT: 'rgba(198,238,255,0.80)',
  GRAY: '#C2C2C2',
  GRAY_DARK: '#949494',
  GRAY_DARKER: '#686868',
  GRAY_HR: 'rgba(210, 210, 210, 0.57)',
  GRAY_TEXT_FIELD: '#EBEBEB',
  GRAY_HEADER: '#262D33',
  GRAY_HEADER_OPACITY: 'rgba(38,45,51, 0.8)',
  GRAY_SUBMIT: '#989898',
  GRAY_ACCOUNT_BUTTON: '#6D6D6D',
  BROWN: '#D8A127',
  PINK: '#FF58F7',
  BLACK_50: 'rgba(0, 0, 0, 0.5)',
  // Custom colors
  custom: {
    table: {
      row: {
        hover: '#E6FABA',
      },
    },
    toast: {
      info: 'rgba(174, 214, 241)',
      success: 'rgba(218, 247, 166)',
      error: 'rgba(255, 87, 51)',
    },
  },
};

export default {
  colors,
};
